(function () {
  console.log("screen 模板 产品是应该是 >>>>>>>>>>>>", location.href);

  /**
   * @等待直到指定类名的元素存在
   * @param {string} className - 目标元素的类名
   * @param {function} callback - 元素存在时执行的回调函 数
   */
  const waitForElement = (selectorClass, attrName, callback) => {
    if (!selectorClass) {
      return console.error("waitForElement >>>>>>>> 未传入类名");
    }

    const observer = new MutationObserver(() => {
      const targetElement = document.querySelector(selectorClass);

      if (attrName) {
        if (targetElement && targetElement[attrName]) {
          observer.disconnect(); // 停止观察

          callback(targetElement); // 执行回调函数
        }
      } else {
        if (targetElement && targetElement.innerHTML.trim()) {
          observer.disconnect(); // 停止观察

          callback(targetElement); // 执行回调函数
        }
      }
    });

    // 开始观察文档主体以检测DOM变化
    observer.observe(document.body, {
      childList: true, // 观察子节点变化
      subtree: true, // 观察所有后代节点
    });
  };

  const parentElement = document.querySelector(".product-form__variants"); // 替换为实际的父元素选择器

  // 格式化价格
  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    // 默认格式化为不带小数的金额
    const formatString = format || "<span class=trans-money>${{amount}}</span>";

    // 确保传入的是数字
    cents = parseFloat(cents);

    function formatWithDelimiters(number, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      // 将分值转换为金额单位
      number = (number / 100).toFixed(2);

      // 将整数和小数分开
      let parts = number.split(".");
      let dollarsAmount = parts[0].replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1" + thousands
      );
      let centsAmount = parts[1];

      // 如果小数部分为 "00" 则省略小数部分，否则保留小数部分
      return centsAmount === "00"
        ? dollarsAmount
        : dollarsAmount + decimal + centsAmount;
    }

    // 调用格式化函数，不带小数的格式化金额
    let value = formatWithDelimiters(cents);

    // 返回格式化的字符串
    return formatString.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  const productMetaApi = {
    priceClass: "price--large",

    unitPriceClass: "",

    updateLabels(variant) {
      const eles = document.querySelectorAll("[new-data-product-label-list]");

      eles.forEach((productLabelList) => {
        if (!productLabelList) {
          return;
        }
        if (!variant) {
          productLabelList.innerHTML = "";
        } else {
          productLabelList.innerHTML = "";
          if (!variant["available"]) {
            productLabelList.innerHTML = `<span class="label label--subdued">${window.themeVariables.strings.collectionSoldOut}</span>`;
          } else if (variant["compare_at_price"] > variant["price"]) {
            let savings = "";
            if (window.themeVariables.settings.discountMode === "percentage") {
              savings = `${Math.round(
                ((variant["compare_at_price"] - variant["price"]) * 100) /
                  variant["compare_at_price"]
              )}%`;
            } else {
              savings = formatMoney(
                variant["compare_at_price"] - variant["price"]
              );
            }
            productLabelList.innerHTML = `<span class="label label--highlight">${window.themeVariables.strings.collectionDiscount.replace(
              "@savings@",
              savings
            )}</span>`;
          }
        }
      });
    },

    updatePrices(variant) {
      const eles = document.querySelectorAll("[new-data-product-price-list]");

      eles.forEach((productPrices) => {
        if (!productPrices) return;

        if (!variant) {
          productPrices.style.display = "none";
        } else {
          productPrices.innerHTML = "";
          if (variant["compare_at_price"] > variant["price"]) {
            productPrices.innerHTML += `<span class="price price--highlight ${
              this.priceClass
            }"><span class="visually-hidden">${
              window.themeVariables.strings.productSalePrice
            }</span>${formatMoney(variant["price"])}</span>`;
            productPrices.innerHTML += `<span class="price price--compare"><span class="visually-hidden">${
              window.themeVariables.strings.productRegularPrice
            }</span>${formatMoney(variant["compare_at_price"])}</span>`;
          } else {
            productPrices.innerHTML += `<span class="price ${
              this.priceClass
            }"><span class="visually-hidden">${
              window.themeVariables.strings.productSalePrice
            }</span>${formatMoney(variant["price"])}</span>`;
          }
          if (variant["unit_price_measurement"]) {
            let referenceValue = "";
            if (variant["unit_price_measurement"]["reference_value"] !== 1) {
              referenceValue = `<span class="unit-price-measurement__reference-value">${variant["unit_price_measurement"]["reference_value"]}</span>`;
            }
            productPrices.innerHTML += `
          <div class="price text--subdued ${this.unitPriceClass}">
            <div class="unit-price-measurement">
              <span class="unit-price-measurement__price">${formatMoney(
                variant["unit_price"]
              )}</span>
              <span class="unit-price-measurement__separator">/</span>
              ${referenceValue}
              <span class="unit-price-measurement__reference-unit">${
                variant["unit_price_measurement"]["reference_unit"]
              }</span>
            </div>
          </div>
        `;
          }
          productPrices.style.display = "";
        }
      });
    },
  };

  /**
   * @全局变量
   * */

  const giftIds = [];

  /**
   * @过滤product_variants
   */
  function filterAndUpdateVariantIds(data) {
    return data.map((item_1) => {
      const variantIds = [];

      // 检查 variant_ids 中的每个 id
      for (const item_2 of data) {
        if (item_1.option1 === item_2.option1) {
          variantIds.push(item_2.id);
        }
      }

      // 更新原对象的 variant_ids 字段
      item_1.featured_image.variant_ids = variantIds;

      return item_1;
    });
  }
  // @切换优惠码
  changeCode = (codeContext, codeNumber) => {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");
    const discountItems = document.querySelectorAll(".discount_code_item");
    if (!variantId) {
      const firstDiscountItem = discountItems[0];
      if (firstDiscountItem) {
        const codeContext = firstDiscountItem.getAttribute("data-code-context");
        const codeNumber = firstDiscountItem.getAttribute("data-code-number");
        const discountModule = document.querySelector(
          ".product_discount_container"
        );

        if (!codeContext || !codeNumber) {
          discountModule.style.display = "none";
        } else {
          discountModule.style.display = "grid";
        }
        const discountCodeElement = document.querySelector(
          ".discount_code_number"
        );
        const discountContextElement = document.querySelector(
          ".discount_code_context"
        );

        if (discountCodeElement) {
          discountCodeElement.innerText = codeNumber;
        }

        if (discountContextElement) {
          discountContextElement.innerText = codeContext;
        }
      }
    }
    discountItems.forEach((item) => {
      if (item.getAttribute("data-vid") === variantId) {
        const codeContext = item.getAttribute("data-code-context");
        const codeNumber = item.getAttribute("data-code-number");
        const discountModule = document.querySelector(
          ".product_discount_container"
        );

        if (!codeContext || !codeNumber) {
          discountModule.style.display = "none";
        } else {
          discountModule.style.display = "grid";
        }
        const discountCodeElement = document.querySelector(
          ".discount_code_number"
        );
        const discountContextElement = document.querySelector(
          ".discount_code_context"
        );

        if (discountCodeElement) {
          discountCodeElement.innerText = codeNumber;
        }

        if (discountContextElement) {
          discountContextElement.innerText = codeContext;
        }
      }
    });
  };
  /**
   * @折扣码复制
   */
  document.addEventListener("click", (event) => {
    const target = event.target;
    if (target.classList.contains("copy_button")) {
      const discountCodeElement = document.querySelector(
        ".discount_code_number"
      );
      if (discountCodeElement) {
        const discountCode = discountCodeElement.innerText;
        navigator.clipboard.writeText(discountCode).then(() => {
          const originalText = target.innerText;
          const originalBgColor = target.style.backgroundColor;
          target.innerText = "COPIED";
          target.style.backgroundColor = "#f5c855";
          setTimeout(() => {
            target.innerText = originalText;
            target.style.backgroundColor = originalBgColor;
          }, 3000);
        });
      }
    }
  });
  /**
   * @处理选中事件
   */
  const handelSelected = () => {
    const searchParamsInstance = new URL(location.href).searchParams;

    const productData = document.querySelector(
      ".product-form .product-form__variants"
    ).product;

    const variantsData = filterAndUpdateVariantIds(productData.variants);

    const variantId =
      Number(searchParamsInstance.get("variant")) || variantsData[0].id;

    // 找到选中的这个变体数据
    const variantData = variantsData.find(
      (variantItem) => variantItem.id === variantId
    );

    /**
     * 点击选项滚动
     **/
    // toggleSizeVisible(true);
    setTimeout(() => {
      changeCode();
    }, 10);
    // 更改价格
    productMetaApi.updateLabels(variantData);

    productMetaApi.updatePrices(variantData);

    // 子变体 id 数组
    const childVariantIds = variantData.featured_image.variant_ids;

    const parentVariantName = variantData.option1;

    const updateVariants = [];

    updateVariants.push({
      name: parentVariantName,
      price: variantData.price,
      compare_at_price: variantData.compare_at_price,
    });

    childVariantIds.forEach((childVariantId) => {
      const childrenVariantData = variantsData.find(
        (variantItem) => variantItem.id === childVariantId
      );

      updateVariants.push({
        name: childrenVariantData.option2,
        price: childrenVariantData.price,
        compare_at_price: childrenVariantData.compare_at_price,
      });
    });

    // End 处理单个变体数据 逻辑
    const variantLabelEles = document.querySelectorAll(
      ".product-form__variants .product-form__option-selector .block-swatch-list .block-swatch__item"
    );

    // 寻找元素下面的第一个文本节点，然后去变体数据里面进行寻找
    variantLabelEles.forEach((variantEle) => {
      const firstLevelText = variantEle
        .querySelector(".product_option_title")
        .innerText.trim();

      updateVariants.forEach((updateVariantItem, updateVariantIndex) => {
        // console.log(
        //   "updateVariantItem >>>>>>>>>>>>>>",
        //   updateVariantItem.name,
        //   "选项文本>>>>>>>>>>",
        //   firstLevelText,
        //   "bool",
        //   updateVariantItem.name === firstLevelText
        // );

        const updateStr = updateVariantItem.name.replace(/ {2,}/g, " ");

        const selectStr = firstLevelText.replace(/ {2,}/g, " ");

        if (updateStr !== selectStr) return;

        // 这里的 0 是 option 模块的选中的那一个 单选商品
        if (updateVariantIndex === 0) {
          // 存眼镜 id
          const giftContainerEle = variantEle.querySelector(
            ".product-gifts-container"
          );

          if (giftContainerEle) {
            giftIds.push($(giftContainerEle).attr("data-variants"));
          }
        }

        const priceEles = variantEle.querySelectorAll(
          ".product_bundle_price .price_with_compare .trans-money"
        );

        const currentPrice = (updateVariantItem.price / 100).toLocaleString();

        const comparePrice = (
          updateVariantItem.compare_at_price / 100
        ).toLocaleString();

        priceEles[0].innerText = "$" + currentPrice;

        if (priceEles.length === 2) {
          if (updateVariantItem.compare_at_price > 0) {
            priceEles[1].innerText = "$" + comparePrice;
          } else {
            priceEles[1].innerText = "";
          }
        }
      });
    });
  };

  const handelRating = () => {
    $(".app_block_new").css("display", "none");

    const productRatingCommentsWraperClassName =
      window.innerWidth < 1024
        ? ".product-rating-comments-wrapper-mobile"
        : ".product-rating-comments-wrapper";

    $(`${productRatingCommentsWraperClassName} .app_block_new`).css(
      "display",
      "block"
    );

    const commentsCount = $(
      `${productRatingCommentsWraperClassName} .rivyoReviewWidget .rivyoReviewAverage .rivyoReviewAverageCount`
    ).text();

       const hideReview = parseInt(commentsCount) == 0;

    if (hideReview) {
      $(`${productRatingCommentsWraperClassName} .app_block_new`).css(
        "display",
        "none"
      );

      $(`${productRatingCommentsWraperClassName}`).css("display", "none");
    }
  };

  /**
   * @监听事件
   * */
  $("#AddToCart_B").show();
  /**
   * 监听选项点击事件
   */
  parentElement.addEventListener("click", (event) => {
    const target = event.target;

    if (
      target.tagName === "LABEL" &&
      target.classList.contains("block-swatch__item")
    ) {
      // console.log(
      //   "在父元素下发生点击事件，目标元素为符合条件的 label 标签：",
      //   target
      // );

      setTimeout(() => {
        handelSelected();
      }, 10);
    }
  });

  //  监听checkout 事件
  document.querySelector(
    ".product-form__option-selector .product-form__option-info"
  ).onclick = function () {
    console.log("Add cart", this);
    let variantId = document.querySelector('[oid="add-to-cart"]').id.value;

    const quantity = document.querySelector(".quantity-selector__input").value;

    const variantParams = [
      {
        variant_id: variantId ? Number(variantId) : 1,
        quantity: quantity ? Number(quantity) : 1,
      },
    ];

    fetch(window.Shopify.routes.root + "wallets/checkouts.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic ZDgwNDg0MWQzZTkzNmNhMmY2NGIyODlmZGFmMTZhYjg=",
      },
      body: JSON.stringify({
        checkout: {
          line_items: variantParams,
          secret: true,
          wallet_name: "ShopifyPay",
          is_upstream_button: true,
          page_type: "product",
          has_selling_plans: false,
          presentment_currency: "USD",
          country: "US",
        },
      }),
    })
      .then((r) => r.json())
      .then((res) => {
        if (!res?.items) return;

        window.location.href = "/cart";
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  /**
   * 监听添加购物车事件
   */
  document
    .querySelector('[oid="add-to-cart"]')
    .addEventListener("submit", function (event) {
      event.preventDefault();
      let vid = document.querySelector('[oid="add-to-cart"]').id.value;

      let quantity = document.querySelector(
        ".quantity-new-selector__input"
      ).value;

      // 这个 礼物 id 在全局里面

      const ids = [giftIds[giftIds.length - 1]];

      const uniqueIds = ids;

      const params = [{ id: vid, quantity: quantity }];

      // 点击购物车加载动画
      $(".loader-button__text").hide();
      $(".loader-button__loader").removeAttr("hidden");
      $(".loader-button__loader").css({
        opacity: "1",
        transform: "translate(-50%, -50%)",
      });

      uniqueIds
        .filter(Boolean)
        .forEach((uniqueId) =>
          params.push({ id: uniqueId, quantity: quantity })
        );

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: params,
        }),
      })
        .then((r) => r.json())
        .then((res) => {
          if (!res?.items) return;

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:reRequest", {
              bubbles: true,
              detail: {},
            })
          );

          $(".loader-button__loader").attr("hidden");
          $(".loader-button__text").show();
          $(".loader-button__loader").css({
            opacity: "0",
            transform: "translate(-50%, -50%)",
          });

          showNotice();
        })
        .catch((error) => {
          console.error("Error:", error);
        });

      return false;
    });

  // 等待 dom 节点里面是否有一个属性
  waitForElement(
    ".product-form .product-form__variants",
    "product",
    (targetEle) => {
      // console.log("成功检测到数据变化 >>>>>>>>>>>>>>>>>>>>", targetEle.product);

      handelSelected();
    }
  );

  waitForElement(
    ".product-rating-comments-wrapper .rivyoReviewWidget .rivyoReviewAverage .rivyoReviewAverageCount",
    null,
    (targetEle) => {
      console.log("评价模块渲染出来了 >>>>>>>>>>>>>>>>>>>>", targetEle);

      handelRating();
    }
  );
})();
// 页面刷新的时候调用一次折扣码
document.addEventListener("DOMContentLoaded", () => {
  changeCode();
});
